__turbopack_context__.v({
  "headingWrap": "Accordion-module-scss-module__Mgz2YG__headingWrap",
  "icon": "Accordion-module-scss-module__Mgz2YG__icon",
  "itemOpen": "Accordion-module-scss-module__Mgz2YG__itemOpen",
  "panel": "Accordion-module-scss-module__Mgz2YG__panel",
  "trigger": "Accordion-module-scss-module__Mgz2YG__trigger",
});
